import { render, staticRenderFns } from "./MainStart.vue?vue&type=template&id=d1ac608c&"
import script from "./MainStart.vue?vue&type=script&lang=js&"
export * from "./MainStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports